import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import {CELULAR_AYUDA, celularEsValido, LoadingBoton} from "../../_helpers";
import {userService} from "../../_services";
import authService from "../../_services/cart/authService";
import alertService from "../../_services/cart/alert.service";

/**
 * El cartel que le pide el celular a las cuentas que se crearon cuando todavía no era obligatorio.
 *
 * <h3>Por qué no se puede cerrar</h3>
 * Porque si se pudiera, nadie lo completaría y la regla nueva valdría sólo para los que se registran
 * de ahora en más — que son justamente los que menos ventas tienen. El celular es lo único que
 * permite que comprador y vendedor se encuentren fuera del sitio; una cuenta sin teléfono es una
 * venta que se traba esperando un mensaje que nadie ve.
 *
 * <h3>Por qué mira `extraInfo` y no redux</h3>
 * El perfil de la sesión vive en `authService`, y `getLogueado()` lo refresca de forma asíncrona al
 * arrancar la app: mirando sólo en el mount, el cartel decidiría con los datos viejos de
 * localStorage. El evento `sesion-actualizada` es el que avisa que ya llegó el perfil de verdad.
 */
export const CompletarCelular = () => {

    const [falta, setFalta] = useState(false);
    const [celular, setCelular] = useState("");
    const [tocado, setTocado] = useState(false);
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        const revisar = () => {
            const detalle = authService.getLoggedUserDetail();

            // `detalle` en undefined es "todavía no cargó", no "no tiene teléfono": sin esta guarda
            // el cartel aparece un instante en cada arranque, incluso para quien ya lo completó.
            setFalta(authService.isAuthenticated() && !!detalle && !detalle.numeroCelular);
        };

        revisar();
        window.addEventListener("sesion-actualizada", revisar);
        return () => window.removeEventListener("sesion-actualizada", revisar);
    }, []);

    const guardar = () => {
        setTocado(true);
        if (!celularEsValido(celular) || guardando) return;

        setGuardando(true);
        userService.guardarCelular(celular).then(
            (perfil) => {
                setGuardando(false);
                // Guardar el perfil que vuelve y no sólo cerrar: si la sesión siguiera sin teléfono,
                // el próximo `revisar()` volvería a abrir el cartel recién completado.
                authService.setExtraInfo(perfil);
                alertService.msg("Listo, ya podés recibir avisos por WhatsApp.");
                setFalta(false);
            },
            (error) => {
                setGuardando(false);
                alertService.error(error);
            }
        );
    };

    const invalido = tocado && !celularEsValido(celular);

    return (
        <Modal show={falta} backdrop="static" keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>Completá tu celular</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p>
                    Nos falta tu número. Es el que usan los compradores y vendedores para escribirte
                    por WhatsApp cuando hay una operación en curso.
                </p>

                <div className="form-group">
                    <label htmlFor="celularPendiente">Celular</label>
                    <input
                        id="celularPendiente"
                        className="form-control"
                        type="tel"
                        inputMode="tel"
                        autoFocus
                        value={celular}
                        placeholder="1155667788"
                        onChange={(e) => setCelular(e.target.value)}
                        onBlur={() => setTocado(true)}
                        onKeyDown={(e) => e.key === "Enter" && guardar()}
                    />
                    {invalido ? (
                        <div className="help-block text-danger">
                            <i className="fas fa-exclamation-circle"></i> Ingresá un celular válido
                        </div>
                    ) : (
                        <small className="form-hint">{CELULAR_AYUDA}</small>
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="button" data-type="primary"
                        disabled={guardando} onClick={guardar}>
                    Guardar
                    <LoadingBoton grabando={guardando}/>
                </button>
            </Modal.Footer>
        </Modal>
    );
};
